'use client'

import { ThemeProvider } from '@/context/ThemeContext'
import { LanguageProvider } from '@/context/LanguageContext'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useState } from 'react'
import { ConfigProvider, theme, App } from 'antd'
import enUS from 'antd/locale/en_US'
import esES from 'antd/locale/es_ES'
import { AuthProvider } from '@/context/AuthContext'
import { ClientProvider } from '@/context/ClientContext'

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(() => new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30000,
        gcTime: 5 * 60 * 1000,
        retry: 1,
        retryOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
      },
    },
  }))

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ClientProvider>
          <ThemeProvider>
            <LanguageProvider>
              <ConfigProvider
                locale={enUS}
                theme={{
                  token: {
                    colorPrimary: '#1677ff',
                  },
                  algorithm: theme.defaultAlgorithm,
                }}
              >
                <App>
                  {children}
                </App>
              </ConfigProvider>
            </LanguageProvider>
          </ThemeProvider>
        </ClientProvider>
      </AuthProvider>
    </QueryClientProvider>
  )
} 